import { render, staticRenderFns } from "./testInfo.vue?vue&type=template&id=cebb1000"
import script from "./testInfo.vue?vue&type=script&lang=js"
export * from "./testInfo.vue?vue&type=script&lang=js"
import style0 from "./testInfo.vue?vue&type=style&index=0&id=cebb1000&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports